/**
 * Remove extraneous leading 0 from phone number to adhere to international format
 * https://en.wikipedia.org/wiki/Telephone_numbers_in_Egypt
 */
export const formatEgyptianPhone = (phone: string) =>
  phone.startsWith("200") ? phone.replace("200", "20") : phone;

/**
 * add plus sign to phone number to adhere to international format
 */
export const formatPhoneWithPlus = (phone: string) =>
  phone.startsWith("+") ? phone : `+${phone}`;

const ARABIC_DIGITS = "٠١٢٣٤٥٦٧٨٩";
const PERSIAN_DIGITS = "۰۱۲۳۴۵۶۷۸۹";

/** Arabic keyboards type ٠–٩ (and some ۰–۹); the number is the same. */
const toAsciiDigits = (value: string): string =>
  value.replace(/[٠-٩۰-۹]/g, (digit) =>
    String(
      Math.max(ARABIC_DIGITS.indexOf(digit), PERSIAN_DIGITS.indexOf(digit)),
    ),
  );

/**
 * Accepts the ways people type an Egyptian mobile — 01xxxxxxxxx,
 * +201xxxxxxxxx, 00201…, in Western or Arabic digits, with or without
 * spaces — and returns the `201xxxxxxxxx` form `users.phone` is stored in,
 * or null when it is not one.
 */
export const normalizeEgyptianMobile = (raw: string): string | null => {
  const digits = toAsciiDigits(raw).replace(/[^\d]/g, "");
  const local = digits.replace(/^(00)?20/, "").replace(/^0/, "");
  return /^1[0125]\d{8}$/.test(local) ? `20${local}` : null;
};
